import { Separator } from '@/components/ui/separator'
import { Skeleton } from '@/components/ui/skeleton'
import React from 'react'

const ProductCardsSkeleton = ({ count }: { count: number }) => {
  return [...Array(count)].map((_, index) => (
    <div key={index}>
      <div className="flex justify-between relative p-5 !pt-2  overflow-hidden">
        <div className="flex gap-4h-full w-full justify-between">
          <div className="basis-2/12 flex flex-col gap-2">
            <Skeleton className="w-[120px] h-[120px]" />
            <Skeleton className="w-[120px] h-8 rounded-sm" />
          </div>
          <div className="basis-10/12 flex flex-col gap-y-5">
            <div className=" flex flex-row items-center justify-between gap-2">
              <Skeleton className="w-40 h-4" />
              <Skeleton className="w-20 h-4 rounded-none" />
              <div className="ml-auto flex flex-row  items-center gap-4 mr-4">
                <Skeleton className="w-8 h-8 rounded-sm" />
                <Skeleton className="w-8 h-8 rounded-sm" />
                <Skeleton className="w-8 h-8 rounded-sm" />
              </div>
            </div>
            <div className=" flex flex-row gap-3 items-end justify-between">
              <div className=" flex flex-col gap-3">
                <Skeleton className="w-20 h-4" />
                <Skeleton className="w-40 h-4" />
              </div>
              <div className=" flex flex-col gap-3">
                <Skeleton className="w-20 h-4" />
                <Skeleton className="w-40 h-4" />
              </div>
              <div className=" flex flex-col gap-3">
                <Skeleton className="w-20 h-4" />
                <Skeleton className="w-40 h-4" />
              </div>
            </div>
            <div className=" flex flex-row gap-3 items-end justify-between">
              <div className=" flex flex-col gap-3">
                <Skeleton className="w-20 h-4" />
                <Skeleton className="w-40 h-4" />
              </div>
              <div className=" flex flex-col  basis-2/3">
                <div className="flex flex-col gap-2">
                  <Skeleton className="w-20 h-4" />
                  <div className="flex gap-1">
                    <Skeleton className="w-7 h-7 rounded-full" />
                    <Skeleton className="w-7 h-7 rounded-full" />
                    <Skeleton className="w-7 h-7 rounded-full" />
                    <Skeleton className="w-7 h-7 rounded-full" />
                    <Skeleton className="w-7 h-7 rounded-full" />
                    <Skeleton className="w-7 h-7 rounded-full" />
                    <Skeleton className="w-7 h-7 rounded-full" />
                    <Skeleton className="w-7 h-7 rounded-full" />
                    <Skeleton className="w-7 h-7 rounded-full" />
                    <Skeleton className="w-7 h-7 rounded-full" />
                    <Skeleton className="w-7 h-7 rounded-full" />
                    <Skeleton className="w-7 h-7 rounded-full" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Skeleton className="w-40 h-4 absolute -right-9 bottom-4 -rotate-45 text-xs flex px-8 rounded-none" />
        </div>
      </div>
      <Separator className="mb-2" />
    </div>
  ))
}

export default ProductCardsSkeleton
